export var TagDeploymentMode;
(function (TagDeploymentMode) {
    TagDeploymentMode["ContentSquare"] = "CONTENTSQUARE";
    TagDeploymentMode["LoadedByClicktale"] = "LOADED_BY_CLICKTALE";
    TagDeploymentMode["LoadClicktalePtc"] = "LOAD_CLICKTALE_PTC";
    TagDeploymentMode["DualCollectionReview"] = "DUAL_COLLECTION_REVIEW";
    TagDeploymentMode["DualCollection"] = "DUAL_COLLECTION";
    TagDeploymentMode["ContentSquareTagClickTaleEndpoints"] = "CONTENTSQUARE_TAG_CLICKTALE_ENDPOINTS";
})(TagDeploymentMode || (TagDeploymentMode = {}));
//# sourceMappingURL=tag.deployment.mode.js.map